import React from 'react';
import type { PropsWithChildren } from 'react';
import type { FieldValues, SubmitHandler } from 'react-hook-form';
import styled from 'styled-components';
import { AnyObjectSchema } from 'yup';

import { Button } from './button';
import { Form } from './form';
import { ButtonsContainer, Modal, ModalContent } from './Modal';

interface Props<T extends FieldValues> {
    modalTitle: string;
    cancelButtonText?: string;
    submitButtonText?: string;
    formSchema?: AnyObjectSchema;
    formDefaultValues?: FieldValues;
    onSubmit?: SubmitHandler<T>;
    buttonDisabled?: boolean;
}

interface ModalProps<T extends FieldValues> extends Props<T> {
    onClose: () => void;
}

export const FormModal = <T extends FieldValues>({
    modalTitle,
    cancelButtonText,
    onClose,
    onSubmit,
    formSchema,
    formDefaultValues,
    submitButtonText,
    children,
}: PropsWithChildren<ModalProps<T>>) => {
    return (
        <Modal onClose={onClose} modalTitle={modalTitle}>
            <StyledForm onSubmit={onSubmit} formSchema={formSchema} defaultValues={formDefaultValues}>
                <ModalContent>{children}</ModalContent>
                <ButtonsContainer $gap={16}>
                    <Button buttonType="secondary" onClick={onClose}>
                        {cancelButtonText ?? 'Cancel'}
                    </Button>
                    <Button buttonType="primary" type="submit">
                        {submitButtonText ?? 'Save changes'}
                    </Button>
                </ButtonsContainer>
            </StyledForm>
        </Modal>
    );
};

const StyledForm = styled(Form)`
    width: 100%;
`;
